import { Feature, Polygon } from "geojson";
import { LngLat } from "mapbox-gl";
import { useCallback, useMemo } from "react";
import { useMap } from "react-map-gl";
import { useNavigate } from "react-router-dom";
import { useMapStore } from "..";
import GeometryService from "../services/geometryService";

export default function useNavigateToInsights(): (shape: Feature<Polygon>) => void {
    const map = useMap().map!;
    const mapStore = useMapStore();
    const navigate = useNavigate();
    const geometryService = useMemo(() => new GeometryService(), []);

    return useCallback((shape: Feature<Polygon>) => {
        const camera = map.getMap().cameraForBounds(geometryService.getBoundaryBox(shape), { padding: shapeFitBoundsPadding });
        if (camera?.center && camera.zoom !== undefined) {
            const center = LngLat.convert(camera.center);
            mapStore.setViewState({
                longitude: center.lng,
                latitude: center.lat,
                zoom: camera.zoom,
            });
        }

        navigate("/insights", {
            state: {
                insightsShape: {
                    type: "FeatureCollection",
                    features: [shape],
                },
            },
        });
    }, []);
}

const shapeFitBoundsPadding = 32;
